import { render, staticRenderFns } from "./VCompaniesTemplate.vue?vue&type=template&id=39eea977&scoped=true&lang=pug"
import script from "./VCompaniesTemplate.vue?vue&type=script&lang=ts"
export * from "./VCompaniesTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VCompaniesTemplate.vue?vue&type=style&index=0&id=39eea977&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eea977",
  null
  
)

/* custom blocks */
import block0 from "./CompaniesTemplate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FExpert%2Fviews%2FCompanies%2Ftemplate%2FVCompaniesTemplate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports